import { ReferralProgramState } from '../../interfaces';
import React from 'react';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var ReferredHeader = function ReferredHeader(_ref) {
  var referrerUser = _ref.referrerUser,
      referralProgram = _ref.referralProgram;
  if (!referrerUser || (referralProgram === null || referralProgram === void 0 ? void 0 : referralProgram.state) !== ReferralProgramState.ACTIVATED) return null;
  return /*#__PURE__*/_jsx("div", {
    className: "h-fill flex justify-center text-center p-4 bg-subkit-alt-light",
    children: /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsxs("strong", {
        children: ["Save ", referralProgram.referredDiscountPercentage, "%"]
      }), " off your subscription", ' ', referralProgram.referredDiscountDuration && "for ".concat(referralProgram.referredDiscountDuration, " month").concat(referralProgram.referredDiscountDuration > 1 ? 's' : ''), referrerUser.firstName && /*#__PURE__*/_jsxs(_Fragment, {
        children: [' thanks to ', /*#__PURE__*/_jsx("strong", {
          children: referrerUser.firstName
        }), " ", /*#__PURE__*/_jsx("strong", {
          children: referrerUser.lastName
        })]
      }), "!"]
    })
  });
};